/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Button } from "../../../components";
import { QRCodeSVG } from "qrcode.react";
import { images } from "../../../config/images";
import { useLocation } from "react-router";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import { toast } from "react-toastify";
import {
  GetAssociateBookingDetails,
  GetGroupSlots,
} from "../../../utilities/api/associateBooking";
import { LableFromEnums } from "../../../utilities";

const AssociateBookingSummary = (props: any) => {
  const { newRef } = props;
  const id = useLocation().state;
  const [printing, setPrinting] = useState(false);
  const [bookingDetails, setBookingDetails] = useState<any>({});
  const [slots, setSlots] = useState<any>([]);
  const { Enums } = useAppSelector((state) => state.enumsArray);
  let EnumArrObj = { ...Enums };
  const ComponentRef = useRef<HTMLDivElement>(null);

  const GetData = async () => {
    const result = await GetAssociateBookingDetails(id);
    const _slots = await GetGroupSlots(id, "false");
    if (result?.statusCode === 200) {
      setBookingDetails(result.data);
    } else {
      toast.error(result.response.data.message);
    }
    if (_slots.statusCode === 200) {
      let data = [] as any;
      _slots.data.forEach((item: any) => {
        item.list.forEach((elem: any) => {
          data.push(elem);
        });
      });
      setSlots(data);
    }
  };

  useEffect(() => {
    GetData();
  }, [ComponentRef]);

  const handlePrint = () => {

    setPrinting(true);
    window.open(
      "/printing/?type=summary&prefix=ACB&id=" + bookingDetails.id + "&hash=" + bookingDetails?.hash,
      "_blank"
    );
    setTimeout(() => {
      setPrinting(false);
    }, 2000);
  };

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            <div className="page-title align-items-center d-flex justify-content-between">
              <Card.Title className="mb-0">
                Associate Booking Summary{" "}
              </Card.Title>
              <Button
                onClick={handlePrint}
                type="button"
                name="print"
                id="print"
                bname={printing ? "Printing" : "Print"}
                disabled={printing}
                className="btn btn-light rounded-1 me-3"
              ></Button>
            </div>
            <hr />
            <div ref={newRef ? newRef : ComponentRef} className="print-content">
              <Row>
                <Col lg={3} className="g-0">
                  <div className="align-items-center d-flex flex-column pt-3">
                    <div className="qr-img">
                      <QRCodeSVG
                        value={JSON.stringify(bookingDetails.id)}
                        size={200}
                        bgColor={"#ffffff"}
                        fgColor={"#000000"}
                        level={"L"}
                        includeMargin={false}
                        imageSettings={{
                          src: images.powerplayicon.default,
                          x: undefined,
                          y: undefined,
                          height: 30,
                          width: 30,
                          excavate: true,
                        }}
                      />
                    </div>
                    <small className="text-uppercase text-muted mt-3">
                      Payment Status
                    </small>
                    <span className="fw-semibold ">
                      {LableFromEnums(
                        bookingDetails?.paymentStatus,
                        EnumArrObj
                      )}
                    </span>
                    <small className="text-uppercase text-muted mt-3">
                      Booking Status
                    </small>
                    <span className="fw-semibold ">
                      {LableFromEnums(bookingDetails?.status, EnumArrObj)}
                    </span>
                  </div>
                </Col>
                <Col lg={"9"}>
                  <div className="court-booking-details  ps-5 pb-5">
                    <Row className="text-start row-mb">
                      <Col>
                        <span className="user-info-title text-info text-uppercase d-block mb-2">
                          Booked Date
                        </span>
                        <span className="user-info">
                          {bookingDetails?.createdAt}
                        </span>
                      </Col>
                      <Col>
                        <span className="user-info-title text-info text-uppercase d-block mb-2">
                          Associate Name
                        </span>
                        <span className="user-info">
                          {bookingDetails?.companyName}
                        </span>
                      </Col>
                    </Row>
                    <Row className="text-start row-mb">
                      <Col>
                        <span className="user-info-title text-info text-uppercase d-block mb-2">
                          Contact Number
                        </span>
                        <span className="user-info">
                          {bookingDetails.user?.countryCode}{" "}
                          {bookingDetails.user?.phone}
                        </span>
                      </Col>
                      <Col>
                        <span className="user-info-title text-info text-uppercase d-block mb-2">
                          Sports Name
                        </span>
                        <span className="user-info">
                          {bookingDetails.sportName}
                        </span>
                      </Col>
                    </Row>
                    <Row className="text-start row-mb">
                      <Col>
                        <span className="user-info-title text-info text-uppercase d-block mb-2">
                          Facility Name
                        </span>
                        <span className="user-info">
                          {bookingDetails.facilityName}
                        </span>
                      </Col>
                      <Col>
                        <span className="user-info-title text-info text-uppercase d-block mb-2">
                          Booked By
                        </span>
                        <span className="user-info">
                          {bookingDetails?.createdByUser?.firstName}{" "}
                          {bookingDetails?.createdByUser?.lastName}
                        </span>
                      </Col>
                    </Row>
                    <hr />
                    <Row>
                      <Col lg={12} className="gy-4">
                        <div className="fw-semibold">Booked Period</div>
                        <div className="fs-7 fw-semibold">
                          {bookingDetails?.startDate} to{" "}
                          {bookingDetails?.endDate}
                        </div>
                        <table className="table table-bordered ">
                          <thead>
                            <tr>
                              <th>Day</th>
                              <th>Selected Time</th>
                              <th>Court Name</th>
                              <th>No. of Slot</th>
                            </tr>
                          </thead>
                          <tbody>
                            {slots?.map((item: any, index: number) => {
                              return (
                                <tr key={"slots" + index}>
                                  <td>{item.bookingDay}</td>
                                  <td>
                                    {item.startTime} to {item.endTime}
                                  </td>
                                  <td>
                                    {item.combinedCourts?.map(
                                      (elem: any, index: number) =>
                                        index !==
                                          item.combinedCourts?.length - 1
                                          ? `${elem.courtName}, `
                                          : elem.courtName
                                    )}
                                  </td>
                                  <td>{item.noOfSlots}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};
export { AssociateBookingSummary };
